/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Llegó el momento de añadirle estilos a nuestras aplicaciones.`}</p>
    <p>{`Puedes encontrar todos los estilos de la Pokédex y agregarlos a tu app `}<a parentName="p" {...{
        "href": "https://gist.github.com/miguelseguramx/307f645f1d18f73b6e2479cced6f388a"
      }}>{`aquí`}</a>{`.`}</p>
    <p>{`Puedes agregarlos de manera global o dividirlos por componentes si deseas.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;